export const industry = {
  province_list: {
    100000: '钢铁行业',
    110000: '电力行业',
    120000: '航空行业',
    130000: '化工行业',
    140000: '建材行业',
    150000: '石化行业',
    160000: '有色金属行业',
    170000: '造纸行业',
    180000: '其他行业'
  },
  city_list: {
    100101: '钢铁生产',
    100200: '其他',
    110102: '发电',
    110203: '电网',
    120104: '民用航空',
    120200: '其他',
    130105: '独立焦化',
    130206: '化工生产',
    130307: '氟化工',
    130400: '其他',
    140108: '平板玻璃生产',
    140209: '水泥生产',
    140317: '陶瓷',
    140400: '其他',
    150110: '石油和天然气生产',
    150211: '石油化工',
    150318: '煤炭',
    150400: '其他',
    160012: '电解铝',
    160113: '镁冶炼',
    160214: '其他有色金属',
    170115: '造纸和纸制品生产',
    170200: '其他',
    180119: '公共建筑',
    180220: '食品烟草酒饮料茶制造',
    180321: '机械设备制造',
    180422: '电子设备制造'
  }
}
